import { DayRouteImport } from './Import'
const { RoutesMap, DayList } = DayRouteImport

const DayRoute = () => [{ path: RoutesMap.DAY_LIST.path, element: <DayList /> }]
export default DayRoute;
